import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectRoutes } from '../system/components/protectRoute';
const MainLayout = lazy(() => import('../layout/MainLayout'));

// APP ROUTES
import AppRoutes from './appRoutes';
import SignAppRoutes from '../main/sign/SignAppRoutes';
import HomeAppRoutes from '../main/home/HomeAppRoutes';
import SettingsAppRoutes from '../main/settings/SettingsAppRoutes';
import AccessDenied from '../main/pages/AccessDenied';
import NotFound from '../main/pages/NotFound';

const GestRoutes = [SignAppRoutes];
const AuthRoutes = [
    AppRoutes,
    HomeAppRoutes,
    SettingsAppRoutes,
];
const AuthRoutesNoLayout = [null];

function RoutesConfig() {
    return (
        <>
            <Suspense>
                <Routes>
                    {GestRoutes}
                    <Route element={<ProtectRoutes />}>
                        <Route element={<MainLayout />}>{AuthRoutes}</Route>
                        <Route
                            path="/access-denied"
                            element={<AccessDenied />}
                        />
                        {AuthRoutesNoLayout}
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </>
    );
}

export default RoutesConfig;
